// Fetch helper function
import fetch from 'helpers/Fetch';

// Import API path/routes constant
import {
  URL_SMART_ENGAGE_DATA,
  URL_SMART_ENGAGE_CAMPAIGNS,
  URL_SMART_ENGAGE_TIMELINE_DATA,
  URL_TIMING_PATTERNS,
  URL_OUTLET_RANKING,
  URL_PROMO_MECHANICS,
} from 'constants/api';

const fetchSmartEngageData = payload => {
  return fetch({
    url: URL_SMART_ENGAGE_DATA,
    data: payload,
  });
};

const fetchSmartEngageTimelineData = payload => {
  return fetch({
    url: URL_SMART_ENGAGE_TIMELINE_DATA,
    data: payload,
  });
};

/** Campaign run windows per track (granular timeline data). POST body matches other Smart Engage APIs. */
const fetchSmartEngageCampaignFrames = payload => {
  return fetch({
    url: URL_SMART_ENGAGE_CAMPAIGNS,
    data: payload,
  });
};

const fetchTimingPatternsData = payload =>
  fetch({ url: URL_TIMING_PATTERNS, data: payload });

const fetchOutletRankingData = payload =>
  fetch({ url: URL_OUTLET_RANKING, data: payload });

const fetchPromoMechanicsData = payload =>
  fetch({ url: URL_PROMO_MECHANICS, data: payload });

export {
  fetchSmartEngageData,
  fetchSmartEngageTimelineData,
  fetchSmartEngageCampaignFrames,
  fetchTimingPatternsData,
  fetchOutletRankingData,
  fetchPromoMechanicsData,
};
